import { useEffect, useRef } from "react";
import { useDrawWheelRaffleMutation } from "../api/drawWheelRaffleApi";

// Запас после ends_at: часы клиента и сервера могут немного расходиться.
const AUTO_DRAW_DELAY_MS = 1000;

interface Params {
  raffleId: number;
  endsAt: string;
  // Только создатель может разыграть (v1) и только неразыгранный промо.
  enabled: boolean;
}

// Истечение таймера = нажатие Start: сами вызываем draw-now. Если страница
// открыта уже после окончания — сразу. Ошибки молча: already_drawn значит,
// что розыгрыш уже прошёл, а инвалидация всё равно подтянет свежий статус.
export const useAutoDraw = ({ raffleId, endsAt, enabled }: Params) => {
  const [drawRaffle] = useDrawWheelRaffleMutation();
  const firedRef = useRef(false);

  useEffect(() => {
    if (!enabled || firedRef.current) return;
    const delay = Math.max(
      0,
      Date.parse(endsAt) - Date.now() + AUTO_DRAW_DELAY_MS,
    );
    const timer = setTimeout(() => {
      firedRef.current = true;
      drawRaffle(raffleId);
    }, delay);
    return () => clearTimeout(timer);
  }, [drawRaffle, enabled, endsAt, raffleId]);
};
